import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://95372bc36792415c930102ba2d6b3f90@o315385.ingest.us.sentry.io/4504965855117312",
  debug: false,
  environment: "production",
  release: "26-0584-liquid-iv-x-access-more-2026-national@94422312421ba43242077a06a9be7a2c26105013",
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
});